import { h } from "preact";
import { useState } from "preact/hooks";
import { styleSupportsType } from "./monogramTypeConfig";

// When more than SHOW_MORE_THRESHOLD styles are available, only the first
// INITIAL_VISIBLE are shown alongside a one-time "Show More" cell that reveals
// the rest (it does not toggle back).
const INITIAL_VISIBLE = 19;
const SHOW_MORE_THRESHOLD = 20;

/**
 * The "Monogram Style" grid (step 2). Renders one cell per monogram style as a
 * radio group; the selected style is highlighted.
 *
 * Only styles offered for the selected monogram `type` are shown (a style with
 * no `monogramTypes` of its own is available for any type).
 */
export default function MonogramStyleSelector({
  styles,
  type,
  selectedId,
  onSelect,
  showMoreLabel,
}) {
  const [expanded, setExpanded] = useState(false);

  const available = styles.filter((style) =>
    styleSupportsType(style.monogramTypes, type),
  );

  const collapsed = !expanded && available.length > SHOW_MORE_THRESHOLD;
  const visible = collapsed ? available.slice(0, INITIAL_VISIBLE) : available;

  return (
    <div className="monogram-style-selector" role="radiogroup">
      {visible.map((style) => {
        const url = style.styleImage?.image?.url;
        const selected = style.id === selectedId;
        return (
          <button
            key={style.id}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`monogram-style-selector__item ${
              selected ? "monogram-style-selector__item--selected" : ""
            }`}
            onClick={() => onSelect(style.id)}
          >
            <span className="monogram-style-selector__image">
              {url && (
                <img
                  src={window.getSizedImageUrl(url, "x106")}
                  alt={style.styleName || ""}
                  loading="lazy"
                />
              )}
            </span>
            <span className="monogram-style-selector__name caption-1">
              {style.styleName}
            </span>
          </button>
        );
      })}

      {collapsed && (
        <div className="monogram-style-selector__item monogram-style-selector__item--more">
          <button
            type="button"
            className="monogram-style-selector__more"
            onClick={() => setExpanded(true)}
          >
            <span className="monogram-style-selector__more-label utility-3">
              {showMoreLabel.split(/\s+/).map((word, index) => (
                <span
                  key={index}
                  className="monogram-style-selector__more-word"
                >
                  {word}
                </span>
              ))}
            </span>
          </button>
        </div>
      )}
    </div>
  );
}
